
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.15.2
 * Query Engine version: 461d6a05159055555eb7dfb337c9fb271cbd4d7e
 */
Prisma.prismaVersion = {
  client: "3.15.2",
  engine: "461d6a05159055555eb7dfb337c9fb271cbd4d7e"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.ActionScalarFieldEnum = makeEnum({
  action_id: 'action_id',
  description: 'description',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.AssessmentScalarFieldEnum = makeEnum({
  assessment_id: 'assessment_id',
  created_by: 'created_by',
  organization_id: 'organization_id',
  assessment_template_id: 'assessment_template_id',
  name: 'name',
  type: 'type',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.AssessmentTemplateScalarFieldEnum = makeEnum({
  assessment_template_id: 'assessment_template_id',
  assessment_template_type: 'assessment_template_type',
  assessment_template_name: 'assessment_template_name',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.CoachScalarFieldEnum = makeEnum({
  coach_id: 'coach_id',
  user_id: 'user_id',
  chat_id: 'chat_id',
  calendar_link: 'calendar_link',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.OrganizationCoachJoinScalarFieldEnum = makeEnum({
  organization_id: 'organization_id',
  coach_id: 'coach_id',
  is_lead: 'is_lead',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.OrganizationEnterpriseAdminJoinScalarFieldEnum = makeEnum({
  organization_id: 'organization_id',
  user_id: 'user_id'
});

exports.Prisma.OrganizationAuditorJoinScalarFieldEnum = makeEnum({
  organization_id: 'organization_id',
  user_id: 'user_id'
});

exports.Prisma.ControlTaskScalarFieldEnum = makeEnum({
  control_task_id: 'control_task_id',
  assessment_id: 'assessment_id',
  assigned_user_id: 'assigned_user_id',
  status: 'status',
  risk_treatment_strategy: 'risk_treatment_strategy',
  priority: 'priority',
  action_plan: 'action_plan',
  person_responsible: 'person_responsible',
  start_date: 'start_date',
  due_date: 'due_date',
  notes: 'notes',
  recommendation: 'recommendation',
  control_task_template_id: 'control_task_template_id',
  impact: 'impact',
  likelihood: 'likelihood',
  custom_name: 'custom_name',
  custom_description: 'custom_description',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.ControlTaskTemplateScalarFieldEnum = makeEnum({
  control_task_template_id: 'control_task_template_id',
  name: 'name',
  description: 'description',
  reference_number: 'reference_number',
  guidance: 'guidance',
  group: 'group',
  priority: 'priority',
  due_date_days: 'due_date_days',
  tags: 'tags',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.EvidenceTypeScalarFieldEnum = makeEnum({
  evidence_type_id: 'evidence_type_id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.DocumentScalarFieldEnum = makeEnum({
  document_id: 'document_id',
  organization_id: 'organization_id',
  created_by: 'created_by',
  s3_document: 's3_document',
  filename: 'filename',
  type: 'type',
  resource_id: 'resource_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.EngagementScalarFieldEnum = makeEnum({
  engagement_id: 'engagement_id',
  organization_id: 'organization_id',
  created_by: 'created_by',
  type: 'type',
  notes: 'notes',
  action_items: 'action_items',
  duration: 'duration',
  met_at: 'met_at',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.MenuScalarFieldEnum = makeEnum({
  menu_id: 'menu_id',
  name: 'name',
  description: 'description',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.OrganizationScalarFieldEnum = makeEnum({
  organization_id: 'organization_id',
  name: 'name',
  entity_type: 'entity_type',
  primary_contact_name: 'primary_contact_name',
  primary_contact_email: 'primary_contact_email',
  billing_contact_name: 'billing_contact_name',
  billing_contact_email: 'billing_contact_email',
  policy_signer_name: 'policy_signer_name',
  policy_signer_title: 'policy_signer_title',
  company_address: 'company_address',
  company_address2: 'company_address2',
  company_city: 'company_city',
  company_region: 'company_region',
  company_postal: 'company_postal',
  ownership_type: 'ownership_type',
  industry_type: 'industry_type',
  industry_role: 'industry_role',
  organization_customers: 'organization_customers',
  jurisdictions: 'jurisdictions',
  previous_assessments: 'previous_assessments',
  country: 'country',
  company_size: 'company_size',
  logo: 'logo',
  stripe_customer_id: 'stripe_customer_id',
  onboarded_at: 'onboarded_at',
  awarego_company_id: 'awarego_company_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  training_template: 'training_template',
  training_template_updated: 'training_template_updated',
  training_template_name: 'training_template_name',
  phishing_test_template: 'phishing_test_template',
  phishing_test_updated: 'phishing_test_updated',
  phishing_template_name: 'phishing_template_name',
  is_system_organization: 'is_system_organization',
  conversation_sid: 'conversation_sid'
});

exports.Prisma.PendingPaymentScalarFieldEnum = makeEnum({
  pending_payment_id: 'pending_payment_id',
  organization_id: 'organization_id',
  plan_id: 'plan_id',
  coaching_hours: 'coaching_hours',
  training_seats: 'training_seats',
  phi_shield_level: 'phi_shield_level',
  phi_shield_seats: 'phi_shield_seats',
  soc2_type1_expiry: 'soc2_type1_expiry',
  soc2_type2_expiry: 'soc2_type2_expiry',
  soc2_assessment_expiry: 'soc2_assessment_expiry',
  pay_on_account: 'pay_on_account',
  discount: 'discount',
  coupon: 'coupon',
  renewal_date: 'renewal_date',
  non_recurring_hours: 'non_recurring_hours',
  im_addon: 'im_addon',
  created_at: 'created_at',
  updated_at: 'updated_at',
  scheduled_date: 'scheduled_date',
  due_now: 'due_now',
  admin_plan_upgrade: 'admin_plan_upgrade'
});

exports.Prisma.ReceiptScalarFieldEnum = makeEnum({
  receipt_id: 'receipt_id',
  organization_id: 'organization_id',
  created_at: 'created_at',
  total: 'total',
  coupon: 'coupon',
  coaching_hours: 'coaching_hours',
  training_seats: 'training_seats',
  phi_shield_level: 'phi_shield_level',
  phi_shield_seats: 'phi_shield_seats',
  soc2_addOns: 'soc2_addOns',
  type: 'type',
  im_addon: 'im_addon'
});

exports.Prisma.PolicyScalarFieldEnum = makeEnum({
  policy_id: 'policy_id',
  policy_template_id: 'policy_template_id',
  organization_id: 'organization_id',
  assigned_to: 'assigned_to',
  review_date: 'review_date',
  created_by: 'created_by',
  status: 'status',
  custom_name: 'custom_name',
  custom_description: 'custom_description',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.PolicyTemplateScalarFieldEnum = makeEnum({
  policy_template_id: 'policy_template_id',
  created_by_id: 'created_by_id',
  name: 'name',
  description: 'description',
  document_id: 'document_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.PlanScalarFieldEnum = makeEnum({
  plan_id: 'plan_id',
  stripe_product_id: 'stripe_product_id',
  name: 'name',
  coaching_hours: 'coaching_hours',
  training_seats: 'training_seats',
  policy_management: 'policy_management',
  incident_management: 'incident_management',
  designated_privacy: 'designated_privacy',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.ResourceScalarFieldEnum = makeEnum({
  resource_id: 'resource_id',
  created_by: 'created_by',
  name: 'name',
  description: 'description',
  category: 'category',
  tags: 'tags',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.RoleScalarFieldEnum = makeEnum({
  role_id: 'role_id',
  role_name: 'role_name',
  role_description: 'role_description',
  created_at: 'created_at',
  updated_at: 'updated_at',
  routes: 'routes'
});

exports.Prisma.SessionScalarFieldEnum = makeEnum({
  session_id: 'session_id',
  created_by: 'created_by',
  organization_id: 'organization_id',
  title: 'title',
  start_time: 'start_time',
  end_time: 'end_time',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.AddOnScalarFieldEnum = makeEnum({
  addon_id: 'addon_id',
  name: 'name',
  description: 'description',
  stripe_product_id: 'stripe_product_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  user_id: 'user_id',
  cognito_id: 'cognito_id',
  email: 'email',
  name: 'name',
  phone: 'phone',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  region: 'region',
  country: 'country',
  postal_code: 'postal_code',
  notes: 'notes',
  job_title: 'job_title',
  notification_settings: 'notification_settings',
  avatar: 'avatar',
  created_at: 'created_at',
  updated_at: 'updated_at',
  organization_id: 'organization_id',
  is_deleted: 'is_deleted',
  invited: 'invited',
  confirmed: 'confirmed',
  last_login: 'last_login',
  community_consent: 'community_consent'
});

exports.Prisma.LegislationScalarFieldEnum = makeEnum({
  legislation_id: 'legislation_id',
  control_task_template_id: 'control_task_template_id',
  legislation_type: 'legislation_type',
  section: 'section',
  link: 'link',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.TrainingProgramScalarFieldEnum = makeEnum({
  training_program_id: 'training_program_id',
  average_score: 'average_score',
  attendance: 'attendance',
  name: 'name',
  organization_id: 'organization_id'
});

exports.Prisma.TrainingProgramAttendeeScalarFieldEnum = makeEnum({
  email: 'email',
  department: 'department',
  training_program_id: 'training_program_id',
  score: 'score'
});

exports.Prisma.PhishingTestScalarFieldEnum = makeEnum({
  phishing_test_id: 'phishing_test_id',
  resilience_score: 'resilience_score',
  phishing_score: 'phishing_score',
  sensitive_data_score: 'sensitive_data_score',
  password_handling_score: 'password_handling_score',
  remote_working_score: 'remote_working_score',
  usb_devices_score: 'usb_devices_score',
  total_attendees: 'total_attendees',
  attendees_completed: 'attendees_completed',
  attendees_started: 'attendees_started',
  name: 'name',
  organization_id: 'organization_id'
});

exports.Prisma.ControlActivityScalarFieldEnum = makeEnum({
  control_activity_id: 'control_activity_id',
  control_task_id: 'control_task_id',
  status_from: 'status_from',
  status_to: 'status_to',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.HowItWorksScalarFieldEnum = makeEnum({
  how_it_works_id: 'how_it_works_id',
  title: 'title',
  description: 'description'
});

exports.Prisma.IncidentStakeholderScalarFieldEnum = makeEnum({
  incident_stakeholder_id: 'incident_stakeholder_id',
  organization_id: 'organization_id',
  type: 'type',
  name: 'name',
  email: 'email',
  phone: 'phone',
  stakeholder_role_id: 'stakeholder_role_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.StakeholderRoleScalarFieldEnum = makeEnum({
  stakeholder_role_id: 'stakeholder_role_id',
  role_name: 'role_name',
  order: 'order'
});

exports.Prisma.IncidentSettingsScalarFieldEnum = makeEnum({
  incident_settings_id: 'incident_settings_id',
  organization_id: 'organization_id',
  incident_prefix: 'incident_prefix',
  enable_external_intake: 'enable_external_intake',
  enable_custom_domain: 'enable_custom_domain',
  enable_anonymous_submission: 'enable_anonymous_submission',
  custom_link_name: 'custom_link_name',
  dns_address: 'dns_address',
  incident_starting_number: 'incident_starting_number',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.IncidentScalarFieldEnum = makeEnum({
  incident_id: 'incident_id',
  incident_report_id: 'incident_report_id',
  organization_id: 'organization_id',
  assigned_user_id: 'assigned_user_id',
  author_id: 'author_id',
  incident_number: 'incident_number',
  breach_incident_type: 'breach_incident_type',
  reporter_first_name: 'reporter_first_name',
  reporter_last_name: 'reporter_last_name',
  reporter_title: 'reporter_title',
  reporter_department: 'reporter_department',
  reporter_phone: 'reporter_phone',
  reporter_email: 'reporter_email',
  reported_timestamp: 'reported_timestamp',
  discovered_timestamp: 'discovered_timestamp',
  occurred_timestamp: 'occurred_timestamp',
  location: 'location',
  description: 'description',
  active: 'active',
  completed_at: 'completed_at',
  anonymous: 'anonymous',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.BreachIncidentCategoryScalarFieldEnum = makeEnum({
  breach_incident_category_id: 'breach_incident_category_id',
  breach_incident_category_name: 'breach_incident_category_name',
  breach_incident_category_description: 'breach_incident_category_description',
  breach_incident_type: 'breach_incident_type',
  order: 'order',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.BreachIncidentSubcategoryScalarFieldEnum = makeEnum({
  breach_incident_subcategory_id: 'breach_incident_subcategory_id',
  breach_incident_category_id: 'breach_incident_category_id',
  subcategory_name: 'subcategory_name',
  order: 'order',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.BreachIncidentExampleScalarFieldEnum = makeEnum({
  breach_incident_example_id: 'breach_incident_example_id',
  breach_incident_category_id: 'breach_incident_category_id',
  breach_incident_example_description: 'breach_incident_example_description',
  order: 'order',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.BreachIncidentCategoryRecordScalarFieldEnum = makeEnum({
  breach_incident_category_record_id: 'breach_incident_category_record_id',
  breach_incident_category_id: 'breach_incident_category_id',
  incident_id: 'incident_id',
  author_id: 'author_id',
  severity: 'severity',
  primary: 'primary',
  active: 'active',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.BreachIncidentSubcategoryRecordScalarFieldEnum = makeEnum({
  breach_incident_subcategory_record_id: 'breach_incident_subcategory_record_id',
  breach_incident_subcategory_id: 'breach_incident_subcategory_id',
  breach_incident_category_record_id: 'breach_incident_category_record_id',
  primary: 'primary',
  active: 'active',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.BreachIncidentSubcategoryOtherRecordScalarFieldEnum = makeEnum({
  breach_incident_subcategory_other_record_id: 'breach_incident_subcategory_other_record_id',
  breach_incident_subcategory_record_id: 'breach_incident_subcategory_record_id',
  other_value: 'other_value',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.IncidentReportActionItemResponseScalarFieldEnum = makeEnum({
  incident_report_action_item_response_id: 'incident_report_action_item_response_id',
  incident_report_id: 'incident_report_id',
  author_id: 'author_id',
  type: 'type',
  measure_taken: 'measure_taken',
  summary: 'summary',
  number_of_affected_individuals: 'number_of_affected_individuals',
  root_cause: 'root_cause',
  complete: 'complete',
  active: 'active',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.IncidentReportActionItemAdditionalResponseScalarFieldEnum = makeEnum({
  incident_report_action_item_additional_response_id: 'incident_report_action_item_additional_response_id',
  incident_report_action_item_additional_response_persistant_id: 'incident_report_action_item_additional_response_persistant_id',
  incident_report_action_item_response_id: 'incident_report_action_item_response_id',
  author_id: 'author_id',
  occurance_date: 'occurance_date',
  who: 'who',
  who_text: 'who_text',
  note: 'note',
  action_name: 'action_name',
  target_completion_date: 'target_completion_date',
  comments: 'comments',
  active: 'active',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.JsonNullValueInput = makeEnum({
  JsonNull: 'JsonNull'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull',
  AnyNull: 'AnyNull'
});
exports.ActionId = makeEnum({
  UserList: 'UserList',
  AccountManage: 'AccountManage',
  ManageAllClients: 'ManageAllClients',
  ManageEnterpriseClients: 'ManageEnterpriseClients',
  OrganizationRead: 'OrganizationRead',
  OrganizationCreate: 'OrganizationCreate',
  OrganizationUpdate: 'OrganizationUpdate',
  OrganizationDelete: 'OrganizationDelete',
  RiskRegistryRead: 'RiskRegistryRead',
  AssessmentRead: 'AssessmentRead',
  AssessmentCreate: 'AssessmentCreate',
  AssessmentUpdate: 'AssessmentUpdate',
  AssessmentDelete: 'AssessmentDelete',
  TrainingProgramRead: 'TrainingProgramRead',
  TrainingProgramCreate: 'TrainingProgramCreate',
  TrainingProgramUpdate: 'TrainingProgramUpdate',
  TrainingProgramDelete: 'TrainingProgramDelete',
  PolicyManagerRead: 'PolicyManagerRead',
  PolicyManagerCreate: 'PolicyManagerCreate',
  PolicyManagerUpdate: 'PolicyManagerUpdate',
  PolicyManagerDelete: 'PolicyManagerDelete',
  DocumentRead: 'DocumentRead',
  DocumentCreate: 'DocumentCreate',
  DocumentDelete: 'DocumentDelete',
  DocumentUpdate: 'DocumentUpdate',
  CoachRead: 'CoachRead',
  CoachCreate: 'CoachCreate',
  CoachUpdate: 'CoachUpdate',
  CoachDelete: 'CoachDelete',
  CoachEngagementRead: 'CoachEngagementRead',
  CoachEngagementCreate: 'CoachEngagementCreate',
  CoachEngagementUpdate: 'CoachEngagementUpdate',
  CoachEngagementDelete: 'CoachEngagementDelete',
  CoachSessionRead: 'CoachSessionRead',
  CoachSessionCreate: 'CoachSessionCreate',
  CoachSessionUpdate: 'CoachSessionUpdate',
  CoachSessionDelete: 'CoachSessionDelete',
  ResourceRead: 'ResourceRead',
  ResourceUpdate: 'ResourceUpdate',
  ResourceCreate: 'ResourceCreate',
  ResourceDelete: 'ResourceDelete',
  UserRead: 'UserRead',
  UserCreate: 'UserCreate',
  UserDelete: 'UserDelete',
  UserUpdate: 'UserUpdate',
  PolicyTemplateRead: 'PolicyTemplateRead',
  PolicyTemplateUpdate: 'PolicyTemplateUpdate',
  PolicyTemplateCreate: 'PolicyTemplateCreate',
  PolicyTemplateDelete: 'PolicyTemplateDelete',
  AssessmentTemplateRead: 'AssessmentTemplateRead',
  AssessmentTemplateUpdate: 'AssessmentTemplateUpdate',
  AssessmentTemplateCreate: 'AssessmentTemplateCreate',
  AssessmentTemplateDelete: 'AssessmentTemplateDelete',
  AuditLogRead: 'AuditLogRead',
  AdminUserRead: 'AdminUserRead',
  AdminUserCreate: 'AdminUserCreate',
  AdminUserUpdate: 'AdminUserUpdate',
  AdminUserDelete: 'AdminUserDelete',
  IncidentStakeholderRead: 'IncidentStakeholderRead',
  IncidentStakeholderCreate: 'IncidentStakeholderCreate',
  IncidentStakeholderUpdate: 'IncidentStakeholderUpdate',
  IncidentStakeholderDelete: 'IncidentStakeholderDelete',
  IncidentRead: 'IncidentRead',
  IncidentCreate: 'IncidentCreate',
  IncidentUpdate: 'IncidentUpdate',
  IncidentDelete: 'IncidentDelete',
  BreachIncidentCategoryRecordRead: 'BreachIncidentCategoryRecordRead',
  BreachIncidentCategoryRecordCreate: 'BreachIncidentCategoryRecordCreate',
  BreachIncidentCategoryRecordUpdate: 'BreachIncidentCategoryRecordUpdate',
  BreachIncidentCategoryRecordDelete: 'BreachIncidentCategoryRecordDelete',
  BreachIncidentSubcategoryRecordRead: 'BreachIncidentSubcategoryRecordRead',
  BreachIncidentSubcategoryRecordCreate: 'BreachIncidentSubcategoryRecordCreate',
  BreachIncidentSubcategoryRecordUpdate: 'BreachIncidentSubcategoryRecordUpdate',
  BreachIncidentSubcategoryRecordDelete: 'BreachIncidentSubcategoryRecordDelete'
});

exports.AssessmentTypes = makeEnum({
  READYASSESMENT: 'READYASSESMENT',
  PIA: 'PIA',
  TRA: 'TRA',
  DPIA: 'DPIA',
  GDPR: 'GDPR',
  ISO27001: 'ISO27001',
  SOC2Type1: 'SOC2Type1',
  SOC2Type2: 'SOC2Type2',
  NIST: 'NIST',
  PCI: 'PCI',
  CCM: 'CCM',
  PenetrationTest: 'PenetrationTest',
  HIPAA: 'HIPAA',
  SOC2: 'SOC2',
  InternalAssessment: 'InternalAssessment',
  SecurityReadinessAssessment: 'SecurityReadinessAssessment',
  CPPA: 'CPPA',
  HIA: 'HIA',
  AI: 'AI'
});

exports.ControlTaskStatus = makeEnum({
  NotImplemented: 'NotImplemented',
  PartiallyImplemented: 'PartiallyImplemented',
  InProgress: 'InProgress',
  Complete: 'Complete',
  AlternateControl: 'AlternateControl',
  MoreResearchRequired: 'MoreResearchRequired',
  Open: 'Open',
  NA: 'NA'
});

exports.ControlTaskRiskTreatmentStrategy = makeEnum({
  Mitigate: 'Mitigate',
  Transfer: 'Transfer',
  Avoid: 'Avoid',
  Accept: 'Accept'
});

exports.ControlTaskPriority = makeEnum({
  High: 'High',
  Medium: 'Medium',
  Low: 'Low'
});

exports.RiskLevel = makeEnum({
  VeryLow: 'VeryLow',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  VeryHigh: 'VeryHigh'
});

exports.DocumentType = makeEnum({
  Policy: 'Policy',
  ControlTask: 'ControlTask',
  Procedure: 'Procedure',
  Agreement: 'Agreement',
  Log: 'Log',
  TechnicalDocumentation: 'TechnicalDocumentation',
  UserDocumentation: 'UserDocumentation',
  TestResult: 'TestResult',
  TrainingMaterial: 'TrainingMaterial',
  Demonstration: 'Demonstration',
  ManagementAssertion: 'ManagementAssertion',
  OtherArtifact: 'OtherArtifact',
  Other: 'Other',
  Reports: 'Reports'
});

exports.MenuId = makeEnum({
  dashboard: 'dashboard',
  admin_dashboard: 'admin_dashboard',
  coach_dashboard: 'coach_dashboard',
  risk_registry: 'risk_registry',
  assessments: 'assessments',
  training: 'training',
  policy_manager: 'policy_manager',
  document_library: 'document_library',
  coach: 'coach',
  chat: 'chat',
  clients: 'clients',
  resources: 'resources',
  privacy_community: 'privacy_community',
  policy_templates: 'policy_templates',
  assessment_templates: 'assessment_templates',
  audit_logs: 'audit_logs',
  phi_settings: 'phi_settings',
  org_settings: 'org_settings',
  organizations: 'organizations',
  incident_management: 'incident_management'
});

exports.Jurisdictions = makeEnum({
  FederalCanada: 'FederalCanada',
  FederalUS: 'FederalUS',
  Europe: 'Europe',
  BritishColumbia: 'BritishColumbia',
  Alberta: 'Alberta',
  Saskatchewan: 'Saskatchewan',
  Manitoba: 'Manitoba',
  Ontario: 'Ontario',
  NovaScotia: 'NovaScotia',
  NewBrunswick: 'NewBrunswick',
  PEI: 'PEI',
  Quebec: 'Quebec',
  Newfoundland: 'Newfoundland',
  Nunavut: 'Nunavut',
  NWTerritories: 'NWTerritories',
  Yukon: 'Yukon',
  Alabama: 'Alabama',
  Alaska: 'Alaska',
  Arizona: 'Arizona',
  Arkansas: 'Arkansas',
  California: 'California',
  Colorado: 'Colorado',
  Connecticut: 'Connecticut',
  Delaware: 'Delaware',
  Florida: 'Florida',
  Georgia: 'Georgia',
  Hawaii: 'Hawaii',
  Idaho: 'Idaho',
  Illinois: 'Illinois',
  Indiana: 'Indiana',
  Iowa: 'Iowa',
  Kansas: 'Kansas',
  Kentucky: 'Kentucky',
  Louisiana: 'Louisiana',
  Maine: 'Maine',
  Maryland: 'Maryland',
  Massachusetts: 'Massachusetts',
  Michigan: 'Michigan',
  Minnesota: 'Minnesota',
  Mississippi: 'Mississippi',
  Missouri: 'Missouri',
  Montana: 'Montana',
  Nebraska: 'Nebraska',
  Nevada: 'Nevada',
  NewHampshire: 'NewHampshire',
  NewJersey: 'NewJersey',
  NewMexico: 'NewMexico',
  NewYork: 'NewYork',
  NorthCarolina: 'NorthCarolina',
  NorthDakota: 'NorthDakota',
  Ohio: 'Ohio',
  Oklahoma: 'Oklahoma',
  Oregon: 'Oregon',
  Pennsylvania: 'Pennsylvania',
  RhodeIsland: 'RhodeIsland',
  SouthCarolina: 'SouthCarolina',
  SouthDakota: 'SouthDakota',
  Tennessee: 'Tennessee',
  Texas: 'Texas',
  Utah: 'Utah',
  Vermont: 'Vermont',
  Virginia: 'Virginia',
  Washington: 'Washington',
  WestVirginia: 'WestVirginia',
  Wisconsin: 'Wisconsin',
  Wyoming: 'Wyoming',
  Other: 'Other'
});

exports.OrganizationOwnership = makeEnum({
  Public: 'Public',
  Private: 'Private'
});

exports.OrganizationIndustry = makeEnum({
  HealthTechnology: 'HealthTechnology',
  FinancialTechnology: 'FinancialTechnology',
  Healthcare: 'Healthcare',
  Finance: 'Finance',
  Ecommerce: 'Ecommerce',
  Insurance: 'Insurance',
  Other: 'Other'
});

exports.Country = makeEnum({
  Canada: 'Canada',
  UnitedStates: 'UnitedStates'
});

exports.IndustryRoles = makeEnum({
  TechnologyProvider: 'TechnologyProvider',
  HealthcareProvider: 'HealthcareProvider',
  ServiceProvider: 'ServiceProvider',
  Other: 'Other'
});

exports.CustomerType = makeEnum({
  Individuals: 'Individuals',
  Private: 'Private',
  Government: 'Government',
  Healthcare: 'Healthcare',
  Other: 'Other'
});

exports.PreviousPolicies = makeEnum({
  PIA: 'PIA',
  TRA: 'TRA',
  SOC2Type1: 'SOC2Type1',
  SOC2Type2: 'SOC2Type2',
  ISO27001: 'ISO27001',
  GDPR: 'GDPR',
  Other: 'Other',
  None: 'None'
});

exports.ReceiptType = makeEnum({
  Subscription: 'Subscription',
  Update: 'Update',
  OneTime: 'OneTime',
  Renewal: 'Renewal'
});

exports.PolicyStatus = makeEnum({
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Complete: 'Complete',
  NeedsReview: 'NeedsReview'
});

exports.Routes = makeEnum({
  AUTH_LOGIN: 'AUTH_LOGIN',
  AUTH_FORGOT_PASSWORD: 'AUTH_FORGOT_PASSWORD',
  AUTH_REGISTER: 'AUTH_REGISTER',
  AUTH_RESET_PASSWORD: 'AUTH_RESET_PASSWORD',
  AUTH_VERIFY_MFA: 'AUTH_VERIFY_MFA',
  PLAN_SELECTION: 'PLAN_SELECTION',
  PAYMENTS: 'PAYMENTS',
  DASHBOARD: 'DASHBOARD',
  RISK_REGISTRY: 'RISK_REGISTRY',
  TRAINING: 'TRAINING',
  TRAINING_HUMAN_RISK: 'TRAINING_HUMAN_RISK',
  TRAINING_TRAINING: 'TRAINING_TRAINING',
  DOCUMENTS: 'DOCUMENTS',
  COACH: 'COACH',
  CHAT: 'CHAT',
  ORGANIZATIONS: 'ORGANIZATIONS',
  CLIENTS: 'CLIENTS',
  CLIENTS_CREATE: 'CLIENTS_CREATE',
  PHI_SETTINGS: 'PHI_SETTINGS',
  ADMIN_DASHBOARD: 'ADMIN_DASHBOARD',
  COACH_DASHBOARD: 'COACH_DASHBOARD',
  RESOURCES: 'RESOURCES',
  RESOURCES_CREATE: 'RESOURCES_CREATE',
  POLICY_TEMPLATES: 'POLICY_TEMPLATES',
  ADMIN_POLICY_CREATE: 'ADMIN_POLICY_CREATE',
  ASSESSMENT_TEMPLATES: 'ASSESSMENT_TEMPLATES',
  CONTROL_TASK_TEMPLATES: 'CONTROL_TASK_TEMPLATES',
  CONTROL_TASK_TEMPLATE_CREATE: 'CONTROL_TASK_TEMPLATE_CREATE',
  POLICIES: 'POLICIES',
  POLICY_CREATE: 'POLICY_CREATE',
  ASSESSMENTS: 'ASSESSMENTS',
  ASSESSMENT_CREATE: 'ASSESSMENT_CREATE',
  INCIDENT_MANAGEMENT: 'INCIDENT_MANAGEMENT',
  INCIDENT_MANAGEMENT_SETTINGS: 'INCIDENT_MANAGEMENT_SETTINGS',
  UNAUTHORIZED: 'UNAUTHORIZED',
  PROFILE_USER: 'PROFILE_USER',
  PROFILE_ORGANIZATION: 'PROFILE_ORGANIZATION',
  COMMUNITY: 'COMMUNITY'
});

exports.HowWorksTitles = makeEnum({
  Coach: 'Coach',
  Assessments: 'Assessments',
  Risks: 'Risks',
  Trainees: 'Trainees',
  RiskRegistry: 'RiskRegistry',
  Training: 'Training',
  PolicyManager: 'PolicyManager',
  DocumentLibrary: 'DocumentLibrary',
  Clients: 'Clients',
  Resources: 'Resources',
  AuditLogs: 'AuditLogs',
  PolicyTemplates: 'PolicyTemplates',
  AssessmentTemplates: 'AssessmentTemplates',
  PHISettings: 'PHISettings'
});

exports.StakeholderType = makeEnum({
  Internal: 'Internal',
  External: 'External'
});

exports.BreachIncidentType = makeEnum({
  Breach: 'Breach',
  Incident: 'Incident'
});

exports.IncidentReportActionItemResponseType = makeEnum({
  Containment: 'Containment',
  Investigation: 'Investigation',
  Communication: 'Communication',
  MandatoryNotification: 'MandatoryNotification',
  Remediation: 'Remediation'
});

exports.Prisma.ModelName = makeEnum({
  Action: 'Action',
  Assessment: 'Assessment',
  AssessmentTemplate: 'AssessmentTemplate',
  Coach: 'Coach',
  OrganizationCoachJoin: 'OrganizationCoachJoin',
  OrganizationEnterpriseAdminJoin: 'OrganizationEnterpriseAdminJoin',
  OrganizationAuditorJoin: 'OrganizationAuditorJoin',
  ControlTask: 'ControlTask',
  ControlTaskTemplate: 'ControlTaskTemplate',
  EvidenceType: 'EvidenceType',
  Document: 'Document',
  Engagement: 'Engagement',
  Menu: 'Menu',
  Organization: 'Organization',
  PendingPayment: 'PendingPayment',
  Receipt: 'Receipt',
  Policy: 'Policy',
  PolicyTemplate: 'PolicyTemplate',
  Plan: 'Plan',
  Resource: 'Resource',
  Role: 'Role',
  Session: 'Session',
  AddOn: 'AddOn',
  User: 'User',
  Legislation: 'Legislation',
  TrainingProgram: 'TrainingProgram',
  TrainingProgramAttendee: 'TrainingProgramAttendee',
  PhishingTest: 'PhishingTest',
  ControlActivity: 'ControlActivity',
  HowItWorks: 'HowItWorks',
  IncidentStakeholder: 'IncidentStakeholder',
  StakeholderRole: 'StakeholderRole',
  IncidentSettings: 'IncidentSettings',
  Incident: 'Incident',
  BreachIncidentCategory: 'BreachIncidentCategory',
  BreachIncidentSubcategory: 'BreachIncidentSubcategory',
  BreachIncidentExample: 'BreachIncidentExample',
  BreachIncidentCategoryRecord: 'BreachIncidentCategoryRecord',
  BreachIncidentSubcategoryRecord: 'BreachIncidentSubcategoryRecord',
  BreachIncidentSubcategoryOtherRecord: 'BreachIncidentSubcategoryOtherRecord',
  IncidentReportActionItemResponse: 'IncidentReportActionItemResponse',
  IncidentReportActionItemAdditionalResponse: 'IncidentReportActionItemAdditionalResponse'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
